import React, { FC } from 'react';
import styled from 'styled-components';
import HandCard from './HandCard';
import { BRICK, Note as Pen, Panel, Title } from './deck';
import type { HandCardDef } from './handModel';

const Inner = styled.div<{ $bare: boolean }>`
  position: relative;
  display: flex;
  gap: 14px;
  padding: ${(p) => (p.$bare ? '0' : '14px')};
  align-items: flex-start;
`;

const Text = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  font-size: 0.78rem;
  line-height: 1.45;
  color: #374151;
`;

interface CardDetailProps {
  card: HandCardDef;
  /** the big face (124 wide) on wide screens, 96 otherwise */
  wide: boolean;
  /** no paper panel around it, for a detail inside a prompt or the modal */
  bare?: boolean;
  /** the action slot under "acts:" (a play button, a line, keep or swap) */
  children?: React.ReactNode;
}

/**
 * One card read in full: the face, its name, what it does and when it acts,
 * with an action slot under that. The hand's lifted card, an incoming offer,
 * the card picked to swap out and the new-card modal all use it.
 */
const CardDetail: FC<CardDetailProps> = ({ card, wide, bare = false, children }) => {
  const body = (
    <Inner $bare={bare}>
      <HandCard card={card} w={wide ? 124 : 96} h={wide ? 172 : 134} />
      <Text>
        <Title>{card.name}</Title>
        {card.text}
        <Pen color={BRICK} style={{ marginTop: 6 }}>
          acts: {card.when}
        </Pen>
        {children != null && children !== false && <div style={{ marginTop: 10 }}>{children}</div>}
      </Text>
    </Inner>
  );
  return bare ? body : <Panel>{body}</Panel>;
};

export default CardDetail;
